var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAudioTextIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    x: "0px",
    y: "0px",
    viewBox: "0 0 16 16",
    id: "svg8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs6"
  }, /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "prefix__Rectangle_2512",
    d: "M0 0h16v16H0z",
    "data-name": "Rectangle 2512",
    transform: "translate(42 10)",
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "prefix__Rectangle_2514",
    d: "M0 0h16v16H0z",
    "data-name": "Rectangle 2514",
    transform: "translate(42 10)",
    stroke: "#707070",
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__clip-path-6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "prefix__Rectangle_2514-7",
    d: "M0 0h16v16H0z",
    "data-name": "Rectangle 2514",
    transform: "translate(42 10)",
    stroke: "#707070",
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__clip-path-5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "prefix__Rectangle_2514-3",
    d: "M0 0h16v16H0z",
    "data-name": "Rectangle 2514",
    transform: "translate(42 10)",
    stroke: "#707070",
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__clip-path-62"
  }, /*#__PURE__*/React.createElement("path", {
    id: "prefix__Rectangle_2514-9",
    d: "M0 0h16v16H0z",
    "data-name": "Rectangle 2514",
    transform: "translate(42 10)",
    stroke: "#707070",
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("style", {
    id: "style4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g985",
    transform: "matrix(.9895 0 0 .9895 -10.906 10.935)",
    stroke: "none",
    strokeOpacity: 1,
    fill: "currentColor",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("path", {
    id: "prefix__microphone",
    d: "M17.58-4.008h-.312a.312.312 0 00-.313.312v.937a2.498 2.498 0 01-2.748 2.486A2.574 2.574 0 0111.96-2.87v-.826a.312.312 0 00-.312-.312h-.312a.312.312 0 00-.313.312v.784A3.542 3.542 0 0013.99.634v.667h-1.093a.312.312 0 00-.312.312v.312a.312.312 0 00.312.312h3.123a.312.312 0 00.312-.312v-.312a.312.312 0 00-.312-.312h-1.093V.64a3.438 3.438 0 002.966-3.4v-.937a.312.312 0 00-.312-.312zM14.457-.885a1.874 1.874 0 001.874-1.874V-5.88a1.874 1.874 0 00-3.747 0v3.122a1.874 1.874 0 001.873 1.874zm-.937-4.996a.937.937 0 011.874 0v3.122a.937.937 0 01-1.874 0z",
    strokeWidth: 0.625
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__text",
    d: "M26.82-8.17a.371.371 0 01.372.371v1.859a.371.371 0 01-.372.371h-.371a.371.371 0 01-.372-.371v-.743h-3.346v7.806h1.115a.371.371 0 01.371.372v.371a.371.371 0 01-.371.371h-3.717a.371.371 0 01-.372-.371v-.371a.371.371 0 01.372-.372h1.115v-7.806h-3.346v.743a.371.371 0 01-.371.371h-.372a.371.371 0 01-.372-.371V-7.8a.371.371 0 01.372-.371z",
    strokeWidth: 0.651
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudioTextIcon);
export default __webpack_public_path__ + "static/media/audio-text-icon.cb5ee04c53e4d564ecb2ded475df9c0c.svg";
export { ForwardRef as ReactComponent };